import React from "react";
import { connect } from "react-redux";
import { Switch, Redirect } from "react-router-dom";

//Customs
import PrivateRoute from "../PrivateRoute";

//Selectors
import { isLogged } from "../../store/auth/selectors";

//* ROUTES *//
import SPU from "./SPU";
import ISSS from "./ISSS";
import AFP from "./AFP";
import ISRMensual from "./ISRMensual";
import F910 from "./F910";

const LegalRoutes = ({ isLogged }) => {
  return (
    <Switch>
      <PrivateRoute
        path="/legal/spu"
        component={SPU}
        isAuthenticated={isLogged}
      />
      {/* <PrivateRoute
        path="/legal/isss"
        component={ISSS}
        isAuthenticated={isLogged}
      />
      <PrivateRoute
        path="/legal/afp"
        component={AFP}
        isAuthenticated={isLogged}
      /> */}
      <PrivateRoute
        path="/legal/isr"
        component={ISRMensual}
        isAuthenticated={isLogged}
      />
      <PrivateRoute
        path="/legal/f910"
        component={F910}
        isAuthenticated={isLogged}
      />
      <Redirect to="/" />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  isLogged: isLogged(state),
});

export default connect(mapStateToProps)(LegalRoutes);
